import { Suspense } from "react";
import { PROD_API_URL, STAGING_API_URL } from "../../../../../api/config/env-variables";
import type { TableColumnTypes } from "../../../../../api/infrastructure/table.formatter";
import SchemaFieldDataTable from "../../../../../components/screens/_DatabaseCreateScreen/SchemaFieldDataTable/SchemaFieldDataTable";
import type { SchemaField } from "../../../../../helpers/format-databases";
import NoDataMessage from "../../../utils/NoDataMessage/NoDataMessage";
import Spinner from "../../../utils/Spinner/Spinner";
import "./ApiCard.scss";

const rawBaseUrl =
  process.env.NODE_ENV === "development"
    ? STAGING_API_URL
    : (PROD_API_URL ?? "https://referentiel-admin.xroad.bj/api");
// Ensure the displayed URL always ends with exactly one `/api`, matching the real endpoint,
// regardless of whether the configured base URL already includes it.
const baseUrl = `${(rawBaseUrl ?? "").replace(/\/+$/, "").replace(/\/api$/, "")}/api`;

export default function ApiCard({
  className,
  label,
  method,
  referenceId,
  tableId,
  schema,
  tableColumnTypes,
}: {
  className?: string;
  label: string;
  referenceId?: number;
  tableId: number;
  method: "POST" | "GET" | "PUT" | "DELETE" | "GET_SHOW";
  schema: SchemaField[];
  tableColumnTypes: TableColumnTypes;
}) {
  const url = `/references/${referenceId}/tables/${tableId}/data${method === "PUT" || method === "DELETE" || method === "GET_SHOW" ? "/{id}" : ""}`;
  if (!referenceId) {
    return <NoDataMessage message="Aucun référentiel sélectionné" />;
  }
  return (
    <div className={`ApiCard ${method.toLocaleLowerCase()}${className ? ` ${className}` : ""}`}>
      <div className={`ApiCard-header${method === "GET" ? " disableBorderBottom" : ""}`}>
        <div style={{ padding: "5px" }}>
          <div className="ApiCard-method">{method.endsWith("_SHOW") ? "GET" : method}</div>
        </div>
        <div className="ApiCard-pathNLabel">
          <div className="ApiCard-path">{`${baseUrl}${url}`}</div>
          <div className="ApiCard-label">{label}</div>
        </div>
      </div>
      {method === "GET" && (
        <div className="ApiCard-body">
          <div className="ApiCard-parameters">
            <span className="ApiCard-bodyTitle">Paramètres</span>

            <p className="ApiCard-bodyText">
              Les filtres peuvent être appliqués sous forme de query params
            </p>
          </div>
        </div>
      )}

      {method !== "GET" && (
        <div className="ApiCard-body">
          {(method === "PUT" || method === "DELETE") && (
            <div className="ApiCard-parameters">
              <span className="ApiCard-bodyTitle">Paramètres</span>

              <p className="ApiCard-bodyText">
                <b>{"{id}"} : </b> Id de la ligne à modifier/supprimer
              </p>
            </div>
          )}
          {method !== "DELETE" && (
            <div className="ApiCard-jsonBody mt-2">
              <span className="ApiCard-bodyTitle ">JSON Body properties</span>

              <Suspense fallback={<Spinner />}>
                <SchemaFieldDataTable
                  className="mt-2 ApiCard-dataTable"
                  schemaFields={schema}
                  schemaFieldTypes={tableColumnTypes}
                />
              </Suspense>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
